/**
 * 欢迎页「我的农场」优先主农场：读写 user_menu_usages.last_context（菜单码 HOME_PRIMARY_FARM）
 * 与智慧农场驾驶舱 farmId 上下文对齐（互通读写）。
 */
import { getMenuLastContext, saveMenuLastContext } from '../api';
import {
  loadCockpitLastFarmId,
  persistCockpitLastFarmId,
  HOME_PRIMARY_FARM_MENU_CODE as COCKPIT_HOME_MENU_CODE,
} from '../pages/cockpit/smart-farm/cockpitLastFarmPrefs';

export const HOME_PRIMARY_FARM_MENU_CODE = COCKPIT_HOME_MENU_CODE || 'HOME_PRIMARY_FARM';

/** @returns {Promise<string>} 仅 HOME_PRIMARY_FARM，不含驾驶舱兜底 */
export async function loadHomePrimaryFarmIdOnly() {
  try {
    const res = await getMenuLastContext(HOME_PRIMARY_FARM_MENU_CODE);
    const body = res?.data;
    if (!body?.success) return '';
    const ctx = body?.data?.lastContext;
    return ctx != null ? String(ctx).trim() : '';
  } catch {
    return '';
  }
}

/**
 * 欢迎页主农场：优先 HOME_PRIMARY_FARM，空则回退驾驶舱上次农场。
 * @returns {Promise<string>}
 */
export async function loadHomePrimaryFarmId() {
  const home = await loadHomePrimaryFarmIdOnly();
  if (home) return home;
  try {
    return (await loadCockpitLastFarmId()) || '';
  } catch {
    return '';
  }
}

/**
 * 持久化主农场；同步驾驶舱 last farm（防环：驾驶舱写入时 syncHome 已处理）。
 * @param {string} farmId
 */
export function persistHomePrimaryFarmId(farmId) {
  const id = farmId != null ? String(farmId).trim() : '';
  if (!id) return Promise.resolve();
  // 写驾驶舱且不再回写 home（下方显式写 home）
  persistCockpitLastFarmId(id, { syncHome: false });
  return saveMenuLastContext(HOME_PRIMARY_FARM_MENU_CODE, id).catch(() => {});
}
